<template>
    <toolbar-option>
        <template slot="primary">
            <toggle :value="isChecked" @input="onToggle" />
        </template>
    </toolbar-option>
</template>

<script>
import uniqid from 'uniqid';
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'includeLocations';

export default {
    name: 'dynamic-collection-include-locations',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Include taxonomies and locations data with every search result',
            isChecked: false,
            coordinates: '',
            inputId: uniqid(),
        };
    },

    methods: {
        onToggle(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, isChecked);
            } else {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }

            this.isChecked = isChecked;
        },

        onSelectedElement() {
            const data = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            this.isChecked = !!data;
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}
</style>
